import React from 'react';

export default function ProcurementExpenseCustomPriceTable(props) {
    return (
        <>
            <div className="table__card tw-mt-4">
                <div className="inbud-table_wrapper">
                    <table className="inbud-table">
                        <thead>
                            <tr>
                                <th>{$t('Original Custom Price by Venues')}</th>
                                <th>{$t('Revised Custom Price by Venues')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {props.row.original_custom_prices.map((price, i) => {
                                        return (
                                            <p key={`${props.prefix}-row-${props.index}-original-price-${i}`}>
                                                {price.name}: {price.amount}
                                            </p>
                                        );
                                    })}
                                </td>
                                <td>
                                    {props.row.revised_custom_prices.map((price, i) => {
                                        return (
                                            <p key={`${props.prefix}-row-${props.index}-revised-price-${i}`}>
                                                {price.name}: {price.amount}
                                            </p>
                                        );
                                    })}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
